export default "__VITE_ASSET__DrrESRMj__"